import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_3 = { class: "card-body col-12" }
const _hoisted_4 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_5 = ["aria-selected", "onClick"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 col-md-6" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-6" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "row justify-content-left p-3" }
const _hoisted_17 = { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }
const _hoisted_18 = { class: "card-body shift-card-body" }
const _hoisted_19 = { class: "align-items-center" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "product-details-content" }
const _hoisted_22 = { class: "info ps-0 list-unstyled d-inline-block" }
const _hoisted_23 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_24 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_25 = { class: "col-sm-6 col-12 maximum-graph-size" }
const _hoisted_26 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DateSelector = _resolveComponent("DateSelector")!
  const _component_DocumentInfoPieGraph = _resolveComponent("DocumentInfoPieGraph")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overViewData.productList, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.productName,
                class: "nav-item",
                role: "tablist"
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (index==_ctx.selectedProductIndex)?true:false }]),
                  role: "button",
                  "aria-selected": (index==_ctx.selectedProductIndex)?true:false,
                  onClick: ($event: any) => (_ctx.selectProduct(index))
                }, _toDisplayString(item.text), 11, _hoisted_5)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_DateSelector, { onSelectedDateChanged: _ctx.handleSelectedDateChange }, null, 8, ["onSelectedDateChanged"]),
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Typ licence", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.licenseSelected) = $event)),
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getNewData())),
                    class: "form-select shadow-none fw-semibold rounded-0 col-6"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTypeLicense(), (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.text), 9, _hoisted_11))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.licenseSelected]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Typ účetnictví", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uctSelected) = $event)),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getNewData())),
                    class: "form-select shadow-none fw-semibold rounded-0 col-6"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTypeUct(), (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.text), 9, _hoisted_13))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.uctSelected]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Typ organizace", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organizationSelected) = $event)),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getNewData())),
                    class: "form-select shadow-none fw-semibold rounded-0 col-6"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTypeOrg(), (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.value,
                        value: option.value
                      }, _toDisplayString(option.text), 9, _hoisted_15))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.organizationSelected]
                  ])
                ])
              ])
            ]),
            _createElementVNode("span", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("ul", _hoisted_22, [
                          _cache[11] || (_cache[11] = _createElementVNode("li", { class: "text-para fs-md-15 fs-xxxl-16" }, null, -1)),
                          _createElementVNode("li", _hoisted_23, [
                            _createElementVNode("a", {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirectToEvidence(_ctx.statisticsData.mostFrequentUniqueEvidence, _ctx.overViewData.productList[_ctx.selectedProductIndex].value))),
                              class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none",
                              href: "javascript:void(0);"
                            })
                          ]),
                          _createElementVNode("li", _hoisted_24, [
                            _createElementVNode("a", {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.redirectToEvidence(_ctx.statisticsData.mostFrequentEvidence, _ctx.overViewData.productList[_ctx.selectedProductIndex].value))),
                              class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none",
                              href: "javascript:void(0);"
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }, [
                _createElementVNode("div", { class: "card-body shift-card-body" }, [
                  _createElementVNode("div", { class: "align-items-center" })
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_DocumentInfoPieGraph, {
              graphData: _ctx.documentInfoOverviewList,
              borderDates: _ctx.borderDates
            }, null, 8, ["graphData", "borderDates"])
          ])
        ])
      ])
    ]),
    (_ctx.tableOptions != undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createVNode(_component_DataTable, {
            tableData: _ctx.tableData,
            tableOptions: _ctx.tableOptions,
            onTableRestrictionChange: _ctx.getNewData,
            ref: "tableDataRef"
          }, null, 8, ["tableData", "tableOptions", "onTableRestrictionChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}